import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import { Box, Grid } from '@mui/material';
import Tooltip from '@mui/material/Tooltip';
import { useFormContext } from 'react-hook-form';

import { FormInputText } from '@/components/form/FormInputText';

/* Contact Info
 firstName: '',
lastName: '',
email: '',
phone: '',
organization: '',
*/

export const ContactInfoStep = () => {
    const { control } = useFormContext();

    return (
        <Grid container spacing={3}>
            <Grid container spacing={3} size={{ xs: 12 }}>
                <Grid size={{ xs: 12, sm: 6 }}>
                    <FormInputText
                        name="firstName"
                        control={control}
                        label="First Name"
                        inputFieldProps={{
                            size: 'medium',
                            type: 'text',
                            id: 'firstName',
                        }}
                        controllerProps={{
                            rules: {
                                required: 'Field is required',
                            },
                        }}
                    />
                </Grid>
                <Grid size={{ xs: 12, sm: 6 }}>
                    <FormInputText
                        name="lastName"
                        control={control}
                        label="Last Name"
                        inputFieldProps={{
                            size: 'medium',
                            type: 'text',
                            id: 'lastName',
                        }}
                        controllerProps={{
                            rules: {
                                required: 'Field is required',
                            },
                        }}
                    />
                </Grid>
            </Grid>
            <Grid container spacing={3} size={{ xs: 12 }}>
                <Grid size={{ xs: 12, sm: 6 }}>
                    <FormInputText
                        name="email"
                        control={control}
                        label="Email"
                        inputFieldProps={{
                            size: 'medium',
                            type: 'text',
                            id: 'email',
                        }}
                        controllerProps={{
                            rules: {
                                required: 'Field is required',
                                pattern: {
                                    value: /\S+@\S+\.\S+/,
                                    message: 'Entered value does not match email format',
                                },
                            },
                        }}
                    />
                </Grid>
                <Grid size={{ xs: 12, sm: 6 }}>
                    <FormInputText
                        name="organization"
                        control={control}
                        label="Organization"
                        inputFieldProps={{
                            size: 'medium',
                            type: 'text',
                            id: 'organization',
                        }}
                        controllerProps={{
                            rules: {
                                required: 'Field is required',
                            },
                        }}
                    />
                </Grid>
            </Grid>
            <Grid container spacing={1} size={{ xs: 12 }}>
                <Grid
                    size={{ xs: 12, sm: 6 }}
                    sx={{
                        display: 'flex',
                        gap: 1,
                        alignItems: 'flex-start',
                        justifyContent: 'space-between',
                    }}
                >
                    <FormInputText
                        name="phone"
                        control={control}
                        label="Phone"
                        inputFieldProps={{
                            size: 'medium',
                            type: 'text',
                            id: 'phone',
                            fullWidth: true,
                        }}
                        controllerProps={{
                            rules: {
                                required: 'Field is required',
                                pattern: {
                                    value: /^[+]?[(]?[0-9]{3}[)]?[-\s.]?[0-9]{3}[-\s.]?[0-9]{4,6}$/im,
                                    message: 'Entered value does not match phone format',
                                },
                            },
                        }}
                    />
                    <Tooltip
                        placement="top"
                        title={
                            <Box>
                                Allowed phone formats are:
                                <br />
                                (123) 456-7890
                                <br />
                                (123)456-7890
                                <br />
                                123-456-7890
                                <br />
                                123.456.7890
                                <br />
                                1234567890
                                <br />
                                +31636363634
                                <br />
                                123-45646725
                                <br />
                            </Box>
                        }
                        sx={{ pt: 2 }}
                    >
                        <HelpOutlineIcon fontSize="medium" color="info" />
                    </Tooltip>
                </Grid>
            </Grid>
        </Grid>
    );
};
